import styled from 'styled-components';

import { breakpoints, colors, fontFamily } from '../../ui/variables';

const PADDING_VERTICAL = 20;
const PADDING_HORIZONTAL = 20;

export const PrivacyPolicyStyle = styled.main`
  background-color: ${colors.white};
  width: 100%;
  box-sizing: border-box;

  @media (min-width: ${breakpoints.ipadLandscape.width}px) {
    padding: 30px 40px; 
  }
  

  .privacy-policy-section {
    background-color: ${colors.white};
    border-radius: 20px;
    padding: 40px 44px;

    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      padding: 40px 44px;
    }

    .privacy-policy-content {
      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        margin: 0 auto;
        max-width: 800px;
        width: 100%;
      }

      .forgot-password {
        ${fontFamily.sourceSansPro.regular};
        color: ${colors.softBlue};
        font-size: 14px;
        line-height: 18px;
        margin: 12px 0 26px;
      }

      .privacy-policy-container {
        background-color: #FFFFFF;
        border: 1px solid #95A1B4;
        border-radius: 20px;
        padding: 7px;
        max-height: 60vh;
        height: auto;
        overflow-y: auto; 


        .privacy-policy-container-content{
          padding: 10px;
          height: 100%;
          box-sizing: border-box;

          .terms-of-service-container-description {
            ${fontFamily.sourceSansPro.regular};
            color: #95A1B4;
            font-size: 14px;
            line-height: 20px;

            ul,
            ol,
            ul li,
            ol li {
              margin: 10px 10px 10px 30px; 
              list-style: disc;
            }
          }

          &::-webkit-scrollbar {
            width: 0.5em;
            height: 0.5em;
          }

          &::-webkit-scrollbar-thumb {
            background-color: ${colors.softBlue};
            border-radius: 20px;
            background-clip: padding-box;
          }
        }
      }

      .privacy-policy-head {
        .privacy-policy-head-title {
          ${fontFamily.sourceSansPro.bold};
          color: ${colors.softBlue};
          font-size: 30px;
          line-height: 36px;
          margin-bottom: 8px;
        }

        .privacy-policy-head-description {
          ${fontFamily.sourceSansPro.regular};
          color: ${colors.veryDarkGray};
          font-size: 14px;
          line-height: 20px;
          margin-bottom: 30px;
        }
      }
    }
  }
`;